import React from 'react';
import { PLAYER_THEME_VARS } from '../../theme';
import './EntryScreens.css';

export const EntryPanel: React.FC<{ children: React.ReactNode; wide?: boolean; label: string; actions?: React.ReactNode }> = ({ children, wide, label, actions }) => (
  <main className={`entry-screen ${wide ? 'entry-screen--wide' : ''}`} style={PLAYER_THEME_VARS} aria-label={label}>
    <div className="entry-screen__brand">Helix 2000</div>
    <div className="entry-screen__body">{children}</div>
    {actions && <footer className="entry-screen__footer">{actions}</footer>}
  </main>
);
